export const ADDRESS = {
    GET_ADDRESSES: 'address/GET_ADDRESSES', 
   

};